import React from "react";
import { EmendaParlamentarDetailsPage } from "./emendaParlamentarDetails.page";
import { EmendaParlamentarDetailsProvider } from "./context/emenda-parlamentar-details-context";

export function EmendaParlamentarDetailsFactory() {
    return (
        <EmendaParlamentarDetailsProvider>
            <EmendaParlamentarDetailsPage />
        </EmendaParlamentarDetailsProvider>
    );
}
